export const FETCH_PREOFFER_CANDIDATES = "FETCH_PREOFFER_CANDIDATES";
export const FETCH_PREOFFER_CANDIDATES_SUCCESS =
  "FETCH_PREOFFER_CANDIDATES_SUCCESS";
export const FETCH_PREOFFER_CANDIDATES_FAILURE =
  "FETCH_PREOFFER_CANDIDATES_FAILURE";

export const FETCH_PREOFFER_COUNTS = "FETCH_PREOFFER_COUNTS";
export const FETCH_PREOFFER_COUNTS_SUCCESS = "FETCH_PREOFFER_COUNTS_SUCCESS";
export const FETCH_PREOFFER_COUNTS_FAILURE = "FETCH_PREOFFER_COUNTS_FAILURE";

export const FETCH_BGC_COUNTS = "FETCH_BGC_COUNTS";
export const FETCH_BGC_COUNTS_SUCCESS = "FETCH_BGC_COUNTS_SUCCESS";
export const FETCH_BGC_COUNTS_FAILURE = "FETCH_BGC_COUNTS_FAILURE";

export const FETCH_SLA_COUNTS = "FETCH_SLA_COUNTS";
export const FETCH_SLA_COUNTS_SUCCESS = "FETCH_SLA_COUNTS_SUCCESS";
export const FETCH_SLA_COUNTS_FAILURE = "FETCH_SLA_COUNTS_FAILURE";

export const CHANGE_PREOFFER_STATUS = "CHANGE_PREOFFER_STATUS";
export const CHANGE_PREOFFER_STATUS_SUCCESS = "CHANGE_PREOFFER_STATUS_SUCCESS";
export const CHANGE_PREOFFER_STATUS_FAILURE = "CHANGE_PREOFFER_STATUS_FAILURE";
export const CHANGE_PREOFFER_STATUS_RESET = "CHANGE_PREOFFER_STATUS_RESET";

export const OFFER_STATUS = "OFFER_STATUS";
export const OFFER_STATUS_SUCCESS = "OFFER_STATUS_SUCCESS";
export const OFFER_STATUS_FAILURE = "OFFER_STATUS_FAILURE";
export const OFFER_STATUS_RESET = "OFFER_STATUS_RESET";

export const OFFER_STATUS_WITH_ATTACHMENT = "OFFER_STATUS_WITH_ATTACHMENT";
export const OFFER_STATUS_WITH_ATTACHMENT_SUCCESS =
  "OFFER_STATUS_WITH_ATTACHMENT_SUCCESS";
export const OFFER_STATUS_WITH_ATTACHMENT_FAILURE =
  "OFFER_STATUS_WITH_ATTACHMENT_FAILURE";
export const OFFER_STATUS_WITH_ATTACHMENT_RESET =
  "OFFER_STATUS_WITH_ATTACHMENT_RESET";
